import { h } from "preact";
import { Typography } from "antd";


export default function VeridocTransactionInfoDataSource(transactionInfo) {

    function asImageView() {
        return {
            face_picture: {
                label: "Photo",
                src: `data:image/jpeg;base64, ${transactionInfo?.face_picture}`
            },
            sign_picture: {
                label: "Signature",
                src: `data:image/jpeg;base64, ${transactionInfo?.sign_picture}`
            }
        };
    }

    function asTableView() {
        return {
            columns: [
                {
                    dataIndex: "label",
                },
                {
                    dataIndex: "value",
                    render: (value) => (
                        <Typography.Text
                            type="secondary"
                        >
                            {value}
                        </Typography.Text>
                    ),
                },
            ],
            rows: [
                {
                    label: "Middle name",
                    value: transactionInfo?.middle_name,
                },
                {
                    label: "Last name",
                    value: transactionInfo?.first_name,
                },
                {
                    label: "First name",
                    value: transactionInfo?.last_name,
                },
                {
                    label: "Birth date",
                    value: transactionInfo?.birth_date,
                },
                {
                    label: "IIN",
                    value: transactionInfo?.iin,
                },
                {
                    label: "ID number",
                    value: transactionInfo?.id_number,
                },
                {
                    label: "Place of birth",
                    value: transactionInfo?.birth_place,
                },
                {
                    label: "Issuing authority",
                    value: transactionInfo?.issuer,
                },
                {
                    label: "Valid through",
                    value: `${transactionInfo?.issue_date} - ${transactionInfo?.due_date}`,
                }
            ]
        };
    }

    function isEmpty() {

        const requiredFields = [
            "middle_name",
            "first_name",
            "last_name",
            "id_number",
            "iin",
            "face_picture",
            "sign_picture"
        ];

        if (!transactionInfo) {
            return true;
        }

        return !requiredFields.every(field => (
            transactionInfo.hasOwnProperty(field)
        ));
    }

    return { asImageView, asTableView, isEmpty };
}